export type TranslateFn = (key: string) => string;

export enum EConsentStatus {
    GRANTED = 'granted',
    DENIED = 'denied',
}

export type ConsentStatus = EConsentStatus | null;

export interface ConsentStorageAdapter {
    getConsentStatus: () => ConsentStatus;
    hasUserConsented: () => boolean;
    grantConsent: () => void;
    denyConsent: () => void;
    clearConsent?: () => void;
}
